module.exports = __webpack_public_path__ + "img/sr.6905244b.svg";